export const locale = {
    lang: 'en',
    data: {
        NOTIFICATION_MAPPING: {
            TITLES: {
                APPOINTMENT_REQUESTED: '{{name}} requested a new appointment',
                APPOINTMENT_UPDATED: '{{name}} modified this appointment',
                APPOINTMENT_CONFIRMED: '{{name}} confirmed this appointment',
                APPOINTMENT_DECLINED: '{{name}} declined this appointment',

                MESSAGE_ADDED: '{{name}} added a message about',
                MESSAGE_MODIFIED: '{{name}} updated a message about',

                LISTING: '{{name}} added a listing to their Portfolio',
                EXTERNAL_LISTING: '{{name}} added an external listing to their Portfolio',
                REACTION: 'A listing in their portfolio was {{reaction}} by {{name}}',
                VISITED: '{{name}} viewed a listing',

                EMAIL: '{{name}} opened the email you sent on {{date}}',
                REPORT: '{{name}} opened the {{report}} from {{date}}',

                SEARCH: '{{name}} saved a new search',

                REGISTERED: '{{name}} has registered their myPlaceNYC account',
                CHILD_CUSTOMER: '{{name}} has invited another person to join their myPlaceNYC portfolio',
                CHILD_REGISTERED: '{{childName}} has registered to join {{primaryCustomerName}}\'s myPlaceNYC porfolio',
                SHARED: 'Agent {{agentName}} has shared their customer with you',
                SHARE_UPDATED: '{{agentName}} has changed access to this customer',
                SHARE_DELETED: '{{agentName}} has removed you from a team share',
                SHARE_SELF_DELETED: '{{agentName}} has removed themselves from a team share',

                NEW_MATCHES: 'You have New Matches',
                NEW_MATCH: 'You have {{count}} new matches from {{name}} search {{search}}.',

                OPEN_HOUSES: 'You have upcoming Open Houses',
                OPEN_HOUSE: 'You have an upcoming Open House',

                MARKET_ACTIVITY: 'You have a new automated Market Activity report',
                SMART_REPORT: 'You have a new automated Smart Report',

                UPDATES: 'You have an exclusive listing that needs updating!',
                EXPIRE: 'One of your exclusive listings is expiring and may need attention!',

                FAVORITE_PRICE_CHANGED: "{{name}}'s Favorite Listing {{notificationText}}",
                FAVORITE_STATUS_CHANGED: "{{name}}'s Favorite Listing {{notificationText}}",
                FAVORITE_MAINT_CC_CHANGED: "{{name}}'s Favorite Listing {{notificationText}}",
                FAVORITE_LISTING_AGENT: 'Your Favorite Listing {{notificationText}}',
                FAVORITE_LISTING_UPDATED: 'Your Favorite Listing Updated',

                REMOVED_ACCOUNT: 'Removed Account',
                YOUR: 'your',

                LIKED: 'liked',
                DISLIKED: 'disliked',
                REMOVED: 'removed',
            },
            SUBTITLES: {
                REGISTERED: 'Registered'
            },
            APPOINTMENTS: {
                CONFIRMED: 'CONFIRMED',
                DECLINED: 'DECLINED',
                CONFIRM: 'Accept',
                REJECT: 'Decline'
            },
            REPORT_TYPES: {
                GRID_REPORT: 'Grid Report',
                SUMMARY_REPORT: 'Summary Report',
                DETAIL_REPORT: 'Detail Report',
                FACT_SHEET_REPORT: 'Fact Sheet Report',
                SHOW_SHEET_REPORT: 'Show Sheet Report',
                CMA_REPORT: 'Comparative Market Analysis Report',
                OPEN_HOUSE_REPORT: 'Open House Report',
                MEDIA_REPORT: 'Media Report',
                COMPARISON_REPORT: 'Comparison Report',
                MARKET_ACTIVITY_REPORT: 'Market Activity Report',
                AGENT_ANALYTICS_REPORT: 'Exclusive Deal History Report'
            }
        }
    }
};